// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "劳动与创造",
      "tec": "宋英茜",
      "week": "13周",
      "add": "实训楼E座315管理"
    },
    [
      {
        "sub": "计量经济学",
        "tec": "马铭婧",
        "week": "1-12周",
        "add": "教学楼D座214经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "宋英茜",
        "week": "13周",
        "add": "实训楼E座315管理"
      }
    ],
    {
      "sub": "能源电力工程与绿色低碳技术",
      "tec": "马仕海张翼",
      "week": "1-8周",
      "add": "教学楼D座226经管"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "孙新",
        "week": "1-8周",
        "add": "教学楼A座122信息"
      },
      {
        "sub": "国家安全教育",
        "tec": "孙新",
        "week": "9-12周",
        "add": "教学楼A座122信息"
      }
    ],
    0
  ],
  "2": [
    [
      {
        "sub": "能源企业管理",
        "tec": "郑帅",
        "week": "1-4,6-11周",
        "add": "教学楼D座214经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "宋英茜",
        "week": "13周",
        "add": "实训楼E座315管理"
      }
    ],
    {
      "sub": "劳动与创造",
      "tec": "宋英茜",
      "week": "13周",
      "add": "实训楼E座315管理"
    },
    {
      "sub": "碳核查理论与实务",
      "tec": "艾静超",
      "week": "1-11周",
      "add": "教学楼D座214经管"
    },
    0,
    0
  ],
  "3": [
    {
      "sub": "能源市场调查与预测",
      "tec": "郑帅",
      "week": "1-4,7-11周",
      "add": "教学楼D座214经管"
    },
    {
      "sub": "计量经济学",
      "tec": "马铭婧",
      "week": "1-12周",
      "add": "教学楼D座214经管"
    },
    0,
    0,
    0
  ],
  "4": [
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "孙新",
        "week": "1-8周",
        "add": "教学楼A座222电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "孙新",
        "week": "9-12周",
        "add": "教学楼A座222电力"
      }
    ],
    {
      "sub": "能源企业管理",
      "tec": "郑帅",
      "week": "1,3,7-10周",
      "add": "教学楼D座214经管"
    },
    {
      "sub": "碳核查理论与实务",
      "tec": "艾静超",
      "week": "1-2周",
      "add": "教学楼D座214经管"
    },
    {
      "sub": "就业创业指导",
      "tec": "王星月",
      "week": "2,4,6-8周",
      "add": "教学楼D座215经管"
    },
    0
  ],
  "5": [
    {
      "sub": "碳核查理论与实务",
      "tec": "艾静超",
      "week": "1-11周",
      "add": "教学楼D座214经管"
    },
    {
      "sub": "能源市场调查与预测",
      "tec": "郑帅",
      "week": "1,3,7-11周",
      "add": "教学楼D座214经管"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
